module.exports = __webpack_public_path__ + "static/img/08.2b4f2f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/08.jpg
// module id = W+YR
// module chunks = 0